module.exports = __webpack_public_path__ + "img/close.f85b73ab.svg";